export default {"src":"/_next/static/media/star.469ac915.svg","height":27,"width":28,"blurWidth":0,"blurHeight":0};